export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative w-full h-screen min-h-[600px] flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url("https://public.readdy.ai/ai/img_res/a68c532ce739c7bd39d5ba1d285ff8d0.jpg")',
        }}
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-16 flex flex-col items-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-white/90 text-xs font-medium tracking-widest uppercase">iOS Application Development</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight max-w-4xl">
          Modern Apps for a
          <br />
          <span className="text-emerald-400">Safer Mobile</span> Experience
        </h1>

        <p className="mt-6 text-base md:text-xl text-white/75 max-w-2xl leading-relaxed font-light">
          NOX, d.o.o. builds premium iOS applications — from advanced VPN protection to intelligent device optimization — crafted to elevate everyday mobile life.
        </p>

        <div className="mt-14 flex items-center gap-6">
          <div className="flex flex-col items-center">
            <span className="text-3xl md:text-4xl font-bold text-white">iOS</span>
            <span className="text-white/60 text-xs mt-1 tracking-wide uppercase">Platform</span>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="flex flex-col items-center">
            <span className="text-3xl md:text-4xl font-bold text-white">100%</span>
            <span className="text-white/60 text-xs mt-1 tracking-wide uppercase">Secure</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-white/50 animate-bounce" />
      </div>
    </section>
  );
}
